import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux'

import history from './services/History'
import App from './components/pages/App'
import Admin from './components/pages/Admin/Admin'
// import Home from './components/pages/Home'
import Mapa from './components/pages/Mapa'
import Publications from './components/pages/Publications'
import Downloads from './components/pages/Downloads'
import News from './components/pages/News'
import AboutUs from './components/pages/AboutUs'
import ContactUs from './components/pages/ContactUs'
import ContactUsSuccess from './components/pages/ContactUs/Success.container'
import Research from './components/pages/Research'
import AdminLogin from './components/pages/Admin/Login'
import AdminMain from './components/pages/Admin/Main'
import AdminNewsSave from './components/pages/Admin/NewsSave'
import AdminPublicationsSave from './components/pages/Admin/PublicationsSave'

const AppRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    <App>
      <Component {...props} />
    </App>
  )} />
)

const AdminRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    <Admin>
      <Component {...props} />
    </Admin>
  )} />
)

export const makeMainRoutes = () =>
  <ConnectedRouter history={history}>
    <Switch>
      <AppRoute exact path='/' component={AboutUs} />
      <AppRoute exact path='/mapa' component={Mapa} />
      <AppRoute path='/publicacoes' component={Publications} />
      <AppRoute path='/downloads' component={Downloads} />
      <AppRoute path='/noticias' component={News} />
      {/* <AppRoute path='/sobre' component={AboutUs} /> */}
      <AppRoute exact path='/contato/sucesso' component={ContactUsSuccess} />
      <AppRoute path='/contato' component={ContactUs} />
      <AppRoute path='/pesquisa-agropecuaria' component={Research} />
      <Route path='/login' component={AdminLogin} />
      <AdminRoute exact path='/admin' component={AdminMain} />
      <AdminRoute path='/admin/noticias' component={AdminNewsSave} />
      <AdminRoute path='/admin/publicacoes' component={AdminPublicationsSave} />
    </Switch>
  </ConnectedRouter>



// WEBPACK FOOTER //
// ./src/routes.js